<app-payment-detail-cont
  [isMobile]="isMobile"
  [isModal]="isModal"
  [isTooltip]="isTooltip"
  [showSwipeUp]="showSwipeUp"
  [total]="price?.Total"
  [currencyCode]="currencyCodeValid"
  [conversionRate]="conversionRate"
  [showInfo]="isMobile"
  [discount]="discount$ | async"
  [rows]="rows"
  [subtitles]="subtitles"
  [isUserHistory]="isUserHistory"
  (toggleShowSwipeUp)="toggleShowSwipeUp.emit()">
  <ng-container cashbackContent *ngIf="price">
    <app-benefit-cashback
      [totalPrice]="price.Total"
      [currencyCode]="currencyCodeValid"
      [productReference]="productReference">
    </app-benefit-cashback>
  </ng-container>
</app-payment-detail-cont>